import Form from '@components/form/Form';
import FormRow from 'lib/src/components/form/FormRow';
import TextInput from '@components/form/TextInput';
import Title from 'lib/src/components/typography/Title';
import useForgotPasswordForm from './hooks/useForgotPasswordForm';

const ForgotPassword: React.FC = () => {
    const {
        email,
        handleChange,
        handleSubmit,
        handleCancel,
        isPosting,
        success,
        error,
    } = useForgotPasswordForm();

    return (
        <>
            <div className="login-form-wrapper">
                <div className="login-form">
                    <Title>Forgot Password</Title>
                    <Form
                        onSubmit={handleSubmit}
                        onCancel={handleCancel}
                        isPosting={isPosting}
                        error={error}
                        omitButtons={success}
                    >
                        {success ? (
                            <p>
                                An email has been sent with further instructions on how to reset
                                your password.
                            </p>
                        ) : (
                            <FormRow>
                                <TextInput
                                    name="email"
                                    type="email"
                                    value={email}
                                    label="Email address"
                                    onChange={handleChange}
                                    required
                                />
                            </FormRow>
                        )}
                    </Form>
                </div>
            </div>
        </>
    );
};

export default ForgotPassword;
